
export const DESKTOP_CONTAINER =
  "mx-auto w-full max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-[1280px]";

export const DESKTOP_CONTAINER_NARROW =
  "mx-auto w-full max-w-xl md:max-w-3xl lg:max-w-5xl xl:max-w-[1280px]";

/**
 * Single-purpose pages — one card of facts rather than a grid of content, so
 * the full rail would only stretch each row apart.
 */
export const DESKTOP_CONTAINER_COMPACT = "mx-auto w-full max-w-xl md:max-w-3xl lg:max-w-4xl";
